var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "17px",
    viewBox: "0 0 14 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Trash") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.0793651,1.3968254 C13.2897593,1.3968254 13.4603175,1.56738359 13.4603175,1.77777778 C13.4603175,1.98817196 13.2897593,2.15873016 13.0793651,2.15873016 L12.8168875,2.15873016 C12.7463125,2.15873016 12.687047,2.21313851 12.68424,2.28752394 L12.2285912,14.3622156 C12.19969,15.1280999 11.5586681,15.7460317 10.7936443,15.7460317 L2.66667314,15.7460317 C1.90068693,15.7460317 1.26063942,15.1284155 1.23172622,14.3622156 L0.77607746,2.28752394 C0.773393295,2.21639309 0.713632381,2.15873016 0.643429994,2.15873016 L0.380952381,2.15873016 C0.170558197,2.15873016 0,1.98817196 0,1.77777778 C0,1.56738359 0.170558197,1.3968254 0.380952381,1.3968254 L3.75716945,1.3968254 C3.82598179,1.3968254 3.90269714,1.34449559 3.92986745,1.2765698 L4.10858311,0.829780698 C4.29665928,0.359590248 4.82787997,0 5.33333333,0 L8.12698413,0 C8.63385176,0 9.1631647,0.358356571 9.35173435,0.829780698 L9.53045001,1.2765698 C9.55701613,1.34298514 9.63354164,1.3968254 9.70314801,1.3968254 L13.0793651,1.3968254 Z M6.47619048,4.6984127 L6.47619048,13.3333333 C6.47619048,13.5437275 6.64674867,13.7142857 6.85714286,13.7142857 C7.06753704,13.7142857 7.23809524,13.5437275 7.23809524,13.3333333 L7.23809524,4.6984127 C7.23809524,4.48801851 7.06753704,4.31746032 6.85714286,4.31746032 C6.64674867,4.31746032 6.47619048,4.48801851 6.47619048,4.6984127 Z M3.55572023,4.70961234 L3.80968848,13.344533 C3.81587385,13.5548362 3.99137257,13.7203064 4.20167583,13.714121 C4.41197907,13.7079357 4.5774493,13.532437 4.5712639,13.3221337 L4.31729564,4.68721305 C4.31111027,4.47690982 4.13561156,4.31143959 3.92530829,4.31762499 C3.71500505,4.32381036 3.54953483,4.49930908 3.55572023,4.70961234 Z M9.14302182,4.68721305 L8.88905356,13.3221337 C8.88286817,13.532437 9.04833839,13.7079357 9.25864163,13.714121 C9.46894489,13.7203064 9.64444361,13.5548362 9.65062898,13.344533 L9.90459723,4.70961234 C9.91078263,4.49930908 9.74531241,4.32381036 9.53500917,4.31762499 C9.3247059,4.31143959 9.14920719,4.47690982 9.14302182,4.68721305 Z M4.8159939,1.11274502 L4.70236175,1.3968254 L8.63213262,1.3968254 C8.70062456,1.3968254 8.73726296,1.34509354 8.71173714,1.28127903 L8.64432356,1.11274502 C8.57146014,0.930586489 8.32230766,0.761904762 8.12698413,0.761904762 L5.33333333,0.761904762 C5.13940155,0.761904762 4.88835548,0.931841117 4.8159939,1.11274502 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PN-v1.5---Register-Clubs---Hover-States",
    transform: "translate(-332.000000, -1117.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tooltip-Info-Copy-2",
    transform: "translate(319.000000, 1099.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-color",
    transform: "translate(13.000000, 18.500000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#616A70",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#AC0C0C",
    id: "Black"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.500000, -2.625000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 21 0 21 21 0 21"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.dd5e87efdc3a35f6081a6404eb77c2d6.svg";
export { ForwardRef as ReactComponent };